import React, { FC } from "react";
import styled from "styled-components";
import { SubtotalProps } from "../common/types";
import { convertFromCentsToDollars } from "../../../helpers/currency";
import { Device } from "../../../helpers/SharedHelpers/screenSizes";

const StyledSubtotal = styled.div<Partial<SubtotalProps>>`
  font-weight: 500;
  margin-left: 15px;

  ${({ showLaptop }) =>
    showLaptop &&
    `
    @media ${Device.notLaptop} {
      display: none;
    }
  `}

  ${({ showNotLaptop }) =>
    showNotLaptop &&
    `
    margin-left: auto;

    @media ${Device.laptop} {
      display: none;
    }
  `}
`;

export const Subtotal: FC<SubtotalProps> = ({
  quantity,
  price,
  showLaptop = false,
  showNotLaptop = false,
}) => {
  if (price) {
    return (
      <StyledSubtotal showLaptop={showLaptop} showNotLaptop={showNotLaptop}>
        {convertFromCentsToDollars(quantity * price)}
      </StyledSubtotal>
    );
  }

  return null;
};
